import React from 'react';
import Icon from './Icon';

export default Icon(
  <g>
    <g>
      <polyline points="10.6,12 4.6,6 10.6,0 10.6,0 		" />
    </g>
    <g>
      <rect
        height="12"
        width="2"
        x="1.4"
      />
    </g>
  </g>, '0 0 12 12', 'SkipToStartIcon',
);
